module.exports = __webpack_public_path__ + "assets/facebook-logo.99b1d1bd.svg";